<section class="receive" *ngIf="orderForm" [formGroup]="orderForm">
  <header class="section-head">
    <div>
      <h3>Receive vendor invoice</h3>
      <p>Enter the invoice totals or upload the vendor document for review.</p>
    </div>
    <button type="button" class="outline-btn" (click)="invoiceFileInput.click()" [disabled]="scanBusy">
      <mat-icon>document_scanner</mat-icon>
      <span>{{ scanBusy ? 'Reading invoice…' : 'Scan or upload invoice' }}</span>
    </button>
    <input
      #invoiceFileInput
      type="file"
      accept="application/pdf,image/*"
      hidden
      (change)="onInvoiceFileSelected($event)"
    />
  </header>

  <div class="receive-fields">
    <label>
      <span>Vendor invoice number</span>
      <input formControlName="invoiceNumber" placeholder="Enter invoice #" />
    </label>
    <label class="invoice-date">
      <span>Invoice date</span>
      <mat-datepicker #picker></mat-datepicker>
      <span class="eta-box">
        <input
          [matDatepicker]="picker"
          formControlName="date"
          placeholder="mm/dd/yyyy"
          aria-label="Invoice date"
        />
        <button type="button" class="eta-toggle" (click)="picker.open()" aria-label="Open calendar">
          <mat-icon>calendar_today</mat-icon>
        </button>
      </span>
    </label>
    <label class="money-field">
      <span>Shipping - {{ currency }}</span>
      <b>{{ currencySymbol(currency) }}</b>
      <input formControlName="shipping" inputmode="decimal" aria-label="Shipping" (blur)="formatCurrency($event, orderForm.controls.shipping)" (keyup)="calculateTotal()" />
    </label>
    <label class="money-field">
      <span>Tax - {{ currency }}</span>
      <b>{{ currencySymbol(currency) }}</b>
      <input formControlName="tax" inputmode="decimal" aria-label="Tax" (blur)="formatCurrency($event, orderForm.controls.tax)" (keyup)="calculateTotal()" />
    </label>
    <div class="total">
      <span>Invoice total - {{ currency }}</span>
      <strong>{{ currencySymbol(currency) }}{{ (orderForm.value.total || 0) | number:'1.2-2' }}</strong>
    </div>
  </div>

  <div class="review-note">
    <mat-icon>auto_awesome</mat-icon>
    <span>Uploaded invoices can suggest these fields. An employee must review and confirm before receiving.</span>
  </div>

  <footer class="receive-foot">
    <mat-checkbox [checked]="invoiceVerified" (change)="invoiceVerified = $event.checked">
      I verified the invoice and received the selected frames
    </mat-checkbox>
    <button type="button" class="save-receiving" (click)="saveFrames()" [disabled]="!canSave">
      <mat-icon>check</mat-icon>
      <span>Save receiving</span>
    </button>
  </footer>
</section>
